import { render, staticRenderFns } from "./TabTags.vue?vue&type=template&id=ce724736&scoped=true"
import script from "./TabTags.vue?vue&type=script&lang=ts"
export * from "./TabTags.vue?vue&type=script&lang=ts"
import style0 from "./TabTags.vue?vue&type=style&index=0&id=ce724736&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce724736",
  null
  
)

export default component.exports